import React from 'react';
import { styled } from '@mui/material/styles';
import FormControlLabel, { formControlLabelClasses } from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { Checkbox } from '@mui/material';

const getColors = (theme, color) => {
	const palette = theme.palette[color] || theme.palette.primary;

	return {
		border: palette.main,
		bg: palette.main + '1A', // ~10% opacity
		hover: palette.main + '33', // ~20% opacity
	};
};

const StyledField = styled(FormControlLabel, {
	shouldForwardProp: (prop) => !['checked', 'disabled', 'color'].includes(prop),
})(({ theme, checked, disabled, color = 'primary' }) => {
	const colors = getColors(theme, color);

	const hoverBackground = disabled
		? theme.palette.action.disabledBackground
		: checked
			? colors.hover
			: theme.palette.mode === 'dark'
				? theme.palette.action.hover + '33'
				: theme.palette.grey[50];
	return {
		padding: '2px 6px 2px 2px',
		margin: 0,
		transition: '0.3s',
		borderRadius: '4px',
		width: '100%',
		cursor: disabled ? 'not-allowed' : 'pointer',
		border: `1px solid ${checked ? colors.border : theme.palette.divider}`,
		backgroundColor: disabled
			? theme.palette.action.disabledBackground
			: checked
				? colors.bg
				: theme.palette.white,
		'&:hover': {
			backgroundColor: hoverBackground,
		},
		[`& .${formControlLabelClasses.label}`]: {
			marginLeft: '0.125rem',
			marginRight: '0.25rem',
			display: 'flex',
			flexDirection: 'column',
			color: disabled ? theme.palette.text.disabled : 'inherit',
		},
	};
});

const FolioCheckbox = ({
	component,
	checked,
	onChange,
	disabled = false,
	label = 'Label',
	sublabel = '',
	color = 'primary',
	controlProps = {},
}) => {
	const isControlled = typeof checked === 'boolean';

	const ControlComponent = component ?? Checkbox;

	return (
		<StyledField
			color={color}
			checked={checked}
			disabled={disabled}
			control={
				<ControlComponent
					color={color}
					checked={checked}
					onChange={onChange}
					disabled={disabled || !isControlled}
					inputProps={!isControlled ? { readOnly: true } : {}}
					{...controlProps}
				/>
			}
			label={
				<>
					{label}
					{sublabel && (
						<Typography
							component='span'
							sx={{
								fontSize: '0.875rem',
								color: disabled ? 'text.disabled' : 'text.secondary',
							}}
						>
							{sublabel}
						</Typography>
					)}
				</>
			}
		/>
	);
};

export default FolioCheckbox;
